import { BookingResponseModel } from '../types/BookingModels';

/**
 * Returns true if a booking should block new slot selection.
 * Pending (not yet actioned) and accepted bookings block new slots.
 * Rejected and cancelled bookings do not block.
 */
export const isBlockingBooking = (booking: BookingResponseModel): boolean =>
  !booking.rejected && !booking.isCancelled;

/**
 * Returns true if two half-open time intervals [aStart, aEnd) and [bStart, bEnd) overlap.
 * Edge-touching intervals (e.g. 10:00–10:30 and 10:30–11:00) return false.
 */
export const overlapsWithTimeRange = (
  a: { startIso: string; endIso: string },
  b: { startIso: string; endIso: string }
): boolean => {
  const aStart = new Date(a.startIso).getTime();
  const aEnd = new Date(a.endIso).getTime();
  const bStart = new Date(b.startIso).getTime();
  const bEnd = new Date(b.endIso).getTime();
  return aStart < bEnd && bStart < aEnd;
};

/**
 * Returns true if the given slot overlaps with any active (blocking) existing booking.
 * Applies across all topics/services.
 */
export const slotClashesWithExistingBookings = (
  slot: { startIso: string; endIso: string },
  bookings: BookingResponseModel[]
): boolean =>
  bookings.some(
    (booking) => isBlockingBooking(booking) && overlapsWithTimeRange(slot, booking)
  );
